<template>
    <div>
        <div class="bg-blue-light">
            <div class="main-content py-2">
                <h2 class="main-title p-3">支払方法の変更</h2>
            </div>
        </div>
        <div class="bg-white">
            <div class="main-content p-3">
                <form @submit="formSubmit" id="formUpdatePayment">
                    <div class="form-wrap main-step-company">
                        <div class="d-none d-md-block">
                            <br><br>
                        </div>
                        <div class="container">
                            <div class="row mt-3">
                                <div class="col-12 col-md-3 offset-md-2">
                                    <label class="label1">支払方法 <span class="text-danger">*</span></label>
                                </div>
                                <div class="col-4 col-md-2">
                                    <div class="custom-control custom-radio">
                                        <input type="radio" class="custom-control-input" name="payment_method" value="1" id="payment_type1" v-model="userInfo.payment_method" />
                                        <label class="custom-control-label label1 pt-1 font-weight-light" for="payment_type1">クレジットカード</label>
                                    </div>
                                </div>
                                <div class="col-4 col-md-2">
                                    <div class="custom-control custom-radio">
                                        <input type="radio" class="custom-control-input" name="payment_method" value="2" id="payment_type2" v-model="userInfo.payment_method" />
                                        <label class="custom-control-label label1 pt-1 font-weight-light" for="payment_type2">コンビニ払い</label>
                                    </div>
                                </div>
                                <div class="col-4 col-md-2">
                                    <div class="custom-control custom-radio">
                                        <input type="radio" class="custom-control-input" name="payment_method" value="3" id="payment_type3" v-model="userInfo.payment_method" />
                                        <label class="custom-control-label label1 pt-1 font-weight-light" for="payment_type3">銀行振込</label>
                                    </div>
                                </div>
                            </div>

                            <div v-if="userInfo.payment_method == 1">
                                <div class="row mt-3 border-top pt-3">
                                    <div class="col-12 col-md-10 offset-md-2">
                                        <label class="text-primary small font-weight-bold">※ 新しいクレジットカード情報を入力してください</label>
                                    </div>
                                </div>

                                <div class="row mt-3">
                                    <div class="col-12 col-md-3 offset-md-2">
                                        <label class="label1">名前 <span class="text-danger">*</span></label>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <input inputmode="text" type="text" name="payment_card_name" v-model="userInfo.payment_card_name" class="form-control" placeholder="TAROU YAMADA" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12 col-md-3 offset-md-2">
                                        <label class="label1">カード番号 <span class="text-danger">*</span></label>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <input inputmode="numeric" type="text" name="payment_card_number" v-model="userInfo.payment_card_number" class="form-control" placeholder="0000000000" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12 col-md-3 offset-md-2">
                                        <label class="label1">有効期限 <span class="text-danger">*</span></label>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <input inputmode="text" type="text" class="form-control" placeholder="2025/01" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12 col-md-3 offset-md-2">
                                        <label class="label1">セキュリティコード <span class="text-danger">*</span></label>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <input inputmode="numeric" type="text" class="form-control" placeholder="123" />
                                    </div>
                                </div>
                            </div>

                            <div class="row text-center text-md-left mt-4 mb-4">
                                <div class="col-12 col-md-7 offset-md-5">
                                    <a href="/profile" class="btn btn-secondary">戻る</a>
                                    <button type="submit" class="btn btn-yellow-dark bg-yellow-dark">変更</button>
                                </div>
                            </div>
                        </div>
                        <div class="d-none d-md-block">
                            <br><br>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    props: ['user'],
    components: {},
    data() {
      return {
          userInfo: this.user,
      }
    },
    methods: {
        formSubmit(e) {
            let self = this;
            let requestData = {
                payment_method: self.userInfo.payment_method,
            };
            if (self.userInfo.payment_method == 1) {
                requestData = {
                    payment_method: self.userInfo.payment_method,
                    payment_card_name: self.userInfo.payment_card_name,
                    payment_card_number: self.userInfo.payment_card_number,
                };
            }
            axios.put('/api/update-payment', requestData)
            .then(function (response) {
                
            })
            .catch(function (error) {
                console.log('Error at : ' + error.message);
            });
        },
    }
    
   }
            
</script>